<template>
    <div>
        <datatable 
          :type="'workers'" 
          :rowData="workers" 
          :loadingMessage="loadingMessage" 
          :noRowsMessage="noRowsMessage" 
          :columns="columns" 
          :paginationSize="50">
        </datatable>
    </div>
</template>

<script>
import datatable from "datatables/datatable";

export default {
name: 'work_status',
components: {datatable},
data() {
    return {
      workers: null,
      loadingMessage: 'Loading workers, please wait ...',
      noRowsMessage: 'No workers found',
      columns: [
        {headerName: 'Worker Ref.', minWidth: 100, field: 'internal_finance_ref'},
        {headerName: 'Name', minWidth: 150, field: 'first_name'},
        {headerName: 'Surname', minWidth: 170, field: 'surname'},
        {headerName: 'Submission Deadline', minWidth: 170, valueGetter: this.dateTimesheetFormat, sort: 'asc'},
        {headerName: 'Last Paid Date', minWidth: 170, valueGetter: this.datePaidFormat},
        {headerName: 'Phone No.', minWidth: 150, field: 'phone_number'},
        {headerName: 'Job Title', minWidth: 150, field: 'job_title'},
        {headerName: 'Working For', minWidth: 300, field: 'company_name'},
        {headerName: 'Worker City', minWidth: 150, field: 'city'}
      ]
    }
  },
  beforeMount() {
    this.$bus.$on('table::reload', ($event) => {
      if ($event.table === 'work_status' && ($event.type === 'store' || $event.type === 'update')) {
        this.getWorkers();
      }
    });
  },
  mounted() {
    this.getWorkers();
  },
  methods: {
    getWorkers() {
        axios.get(this.crmApiPath + 'worker/dashboard/not_yet_paid').then(workers => {
            this.workers = workers.data;
        }).catch(error => console.log(error.response));
    },
    dateTimesheetFormat(params) {
      return this.$options.filters.formatDate(params.data.timesheet_deadline);
    },
    datePaidFormat(params) {
      return this.$options.filters.formatDate(params.data.last_paid_submission);
    }
  }
}
</script>